import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const CompletionStatusModal = ({ 
  isOpen, 
  onClose, 
  character, 
  content, 
  currentStatus,
  onUpdate 
}) => {
  const [status, setStatus] = useState(currentStatus);
  const [notes, setNotes] = useState('');

  if (!isOpen) return null;

  const handleSubmit = () => {
    onUpdate(character?.id, content?.id, status, notes);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
      <div 
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative bg-card rounded-xl border border-border shadow-warm-xl w-full max-w-md p-6 md:p-8">
        <div className="flex items-start justify-between mb-6">
          <div>
            <h3 className="text-xl md:text-2xl font-bold text-foreground mb-1">
              Update Completion Status
            </h3>
            <p className="text-sm text-muted-foreground">
              {character?.name} - {content?.name}
            </p>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-lg hover:bg-muted transition-base flex items-center justify-center"
          >
            <Icon name="X" size={20} color="var(--color-foreground)" />
          </button>
        </div>

        <div className="space-y-6">
          <div>
            <label className="text-sm font-medium text-foreground mb-3 block">
              Completion Status
            </label>
            <div className="space-y-2">
              <Checkbox
                label="Completed"
                checked={status === 'completed'}
                onChange={() => setStatus('completed')}
              />
              <Checkbox
                label="In Progress"
                checked={status === 'in-progress'}
                onChange={() => setStatus('in-progress')}
              />
              <Checkbox
                label="Not Started"
                checked={status === 'not-started'}
                onChange={() => setStatus('not-started')}
              />
            </div>
          </div>

          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Notes (Optional)
            </label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e?.target?.value)}
              placeholder="Add any notes about this content..."
              className="w-full h-24 px-4 py-3 bg-input border border-border rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring resize-none"
            />
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              variant="outline"
              onClick={onClose}
              fullWidth
            >
              Cancel
            </Button>
            <Button
              variant="default"
              onClick={handleSubmit}
              fullWidth
            >
              Update Status
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompletionStatusModal;